import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const authHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

export const fetchFacebookLeadSettings = async () => {
  const response = await axios.get(`${API_URL}/FacebookLead/settings`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const saveFacebookLeadSettings = async (payload) => {
  const response = await axios.post(`${API_URL}/FacebookLead/settings`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const fetchFacebookPosts = async ({ pageId = '', accessToken = '' } = {}) => {
  const params = new URLSearchParams();
  if (pageId) params.set('pageId', pageId);
  if (accessToken) params.set('accessToken', accessToken);

  const response = await axios.get(`${API_URL}/FacebookLead/posts?${params.toString()}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const fetchTrackedFacebookPosts = async () => {
  const response = await axios.get(`${API_URL}/FacebookLead/tracked-posts`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const saveTrackedFacebookPost = async (payload) => {
  const response = await axios.post(`${API_URL}/FacebookLead/tracked-posts`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const deleteTrackedFacebookPost = async (id) => {
  const response = await axios.delete(`${API_URL}/FacebookLead/tracked-posts/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};